const apiWorkflow = {
  'get-list': {
    method: 'post',
    url: '/admincp/workflow/list'
  },
  find: {
    method: 'get',
    url: '/admincp/workflow/find?key=KEY'
  },
  add: {
    method: 'post',
    url: '/admincp/workflow'
  },
  delete: {
    method: 'delete',
    url: '/admincp/workflow'
  },
  archive: {
    method: 'delete',
    url: '/admincp/workflow/archive'
  },
  restore: {
    method: 'put',
    url: '/admincp/workflow/restore'
  },
  edit: {
    method: 'put',
    url: '/admincp/workflow/ID'
  },
  getByID: {
    method: 'get',
    url: '/admincp/workflow/ID'
  }
}

export default {
  ...apiWorkflow
}
